export default "__VITE_ASSET__713ad8b0__"